import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { createInstance, Piral, createStandardApi } from 'piral';
import { layout, errors } from './layout';
// @ts-ignore
import PortalCityBackground from './assets/images/PortalCityBackground.png';


const feedUrl = 'https://piral-feed.lime-energy.app/api/v1/pilet/willdan-special-districts-dev';
// const feedUrl = 'http://localhost:9000/api/v1/pilet';


const instance = createInstance({
  state: {
    components: layout,
    errorComponents: errors,
  },
  plugins: [...createStandardApi()],
  requestPilets() {
    return fetch(feedUrl)
      .then((res) => res.json())
      .then((res) => {
        const piletList = res.items.map(i => i.name);
        instance.root.setData('availablePilets', piletList)
        return res.items;
      })
      .catch((error) => {
        console.error('Error fetching pilets:', error);
        return [];
      });
  },
});

async function fetchDataAndInitialize() {
  const InstanceContainer = React.lazy(() => import('./InstanceContainer'));
  try {
    // const response = await fetch(featureUrl);
    // if (!response.ok) {
    //   throw new Error('Failed to fetch data');
    // }
    // const data = await response.json();
    // instance.root.setData('featureFlags', data.flags);
    instance.root.setData('backgroundImage', PortalCityBackground);
    // instance.root.registerMenu("auth-signout-button", () => <SignOutButton app={instance.root} />);
    const root = createRoot(document.querySelector('#app'));
    root.render(<InstanceContainer instance={instance} /> );
  } catch (error) {
    console.error(error);
  }
}

fetchDataAndInitialize();

export default instance;
